<template>
<div class="layout-dialog mkt-ops -main-font">
    <div class="md-layout -head" style="padding-top: 0px;">
        <div class="md-layout-item md-large-size-30 md-medium-size-30 md-small-size-40">
            <md-field class="md-has-value">
                <label>Group Name</label>
                <md-input v-model="value.group_name" readonly class="-font-kanit"></md-input>
            </md-field>
        </div>
        <div class="md-layout-item md-large-size-70 md-medium-size-70 md-small-size-60 checkbox-status">
            <md-checkbox v-model="status" class="md-primary" disabled>Active</md-checkbox>
        </div>
    </div>

    <div id="table-cg-show">
        <div id="divTableHead">
                <div style="width: 11%">Code</div>
                <div style="width: 31%">English Name</div>
                <div style="width: 38%">Thai Name</div>
                <div style="width: 20%; padding-right: 10px;">Price Type</div>
        </div>
        <div id="divTableBody">
            <div :class="'row-bg-gray'" v-for="(item, sIndex) in value.customers" :key="sIndex">
                    <div style="width: 11%">{{ item.code }}</div>
                    <div style="width: 31%" class="nowrap-title -font-kanit" :title="item.title">{{ item.title }}</div>
                    <div style="width: 38%" class="nowrap-title -font-kanit" :title="item.title_th">{{ item.title_th }}</div>
                    <div style="width: 20%;  padding-right: 10px;">{{ item.pricetype_code }}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "cusgomer-group-form",
    props: ["value"],
    watch: {
        // value(data) {
        //     if (data.status == "active") this.status = true;
        //     else this.status = false;
        // }
    },
    mounted(){
        // console.log("log",this.value);
         if (this.value.status == "active") this.status = true;
            else this.status = false;
    },
    create() {
        // console.log("log",this.value);
    },
    data() {
        return {
            status: true
        };
    }
};
</script>

<style lang="scss" scoped>
.customer-group-dialog {
    #table-cg-show {
        #divTableHead {
            width: 99.3%;
            display: -webkit-inline-box;
            font-size: 13px;
            font-weight: bold;
            margin-top: 15px;
            margin-bottom: 10px;

            div {
                // border: 1px solid pink;
                padding-left: 5px;
                padding-right: 5px;

                &.-text-right {
                    text-align: right;
                }

                &.-text-center {
                    text-align: center;
                }
            }
        }

        #divTableBody {
            width: 100%;
            height: calc(80vmin - 230px);
            display: block;
            overflow-y: scroll;
            font-size: 13px;

            >div {
                width: 100%;
                height: 30px;
                display: -webkit-inline-box;
                padding-top: 5px;
                padding-bottom: 5px;

                div {
                    // border: 1px solid pink;
                    padding-left: 5px;
                    padding-right: 5px;

                    &.-text-right {
                        text-align: right;
                    }

                    &.-text-center {
                        text-align: center;
                    }

                    &.nowrap-title {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }

            .row-bg-gray:hover {
                border-radius: 4px;
                background: #ececeb;
            }

            &::-webkit-scrollbar {
                height: 7px;
                width: 8px;
            }
        }
    }
}
</style>
